module.exports = __webpack_public_path__ + "img/36.90080fc0.jpg";